'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$65() {
  this.bmt = null;
  this.bmu = false;
}
export { $c_Lpresto_PrestoRouter$$anon$65 as $c_Lpresto_PrestoRouter$$anon$65 };
$p = $c_Lpresto_PrestoRouter$$anon$65.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$65;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$65() {
}
export { $h_Lpresto_PrestoRouter$$anon$65 as $h_Lpresto_PrestoRouter$$anon$65 };
$h_Lpresto_PrestoRouter$$anon$65.prototype = $p;
$p.P = (function() {
  if ((!this.bmu)) {
    this.bmt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bmu = true;
  }
  return this.bmt;
});
var $d_Lpresto_PrestoRouter$$anon$65 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$65, "presto.PrestoRouter$$anon$65", ({
  OG: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$65 as $d_Lpresto_PrestoRouter$$anon$65 };
//# sourceMappingURL=presto.-Presto-Router$$anon$65.js.map
